let GAMES = [
  {
    name: "Ratchet & Clank: Rift Apart",
    id: 0,
    game_id: "134582",
    release: 1623369600,
    genre: [5, 8, 31],
    platforms: [167],
    summary:
      "Go dimension-hopping with Ratchet and Clank as they take on an evil emperor from another reality. Jump between action-packed worlds and beyond at mind-blowing speeds, complete with dazzling visuals and an insane arsenal.",
    cover: "https://images.igdb.com/igdb/image/upload/t_original/co2str.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/sc8biv.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8biw.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scag31.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scag33.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scag38.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scag34.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scag32.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scag35.jpg",
    ],
    videos: ["https://www.youtube.com/embed/9aJK8K_NnTE"],
  },
  {
    name: "God of War Ragnarök",
    id: 1,
    game_id: "112875",
    release: 1667952000,
    genre: [25, 31],
    platforms: [48, 167],
    summary:
      "God of War: Ragnarök is the ninth installment in the God of War series and the sequel to 2018's God of War. Continuing with the Norse mythology theme, the game is set in ancient Norway and feature series protagonists Kratos, the former Greek God of War, and his young son Atreus. The game is expected to kick off the events of Ragnarök, where Kratos and Atreus must journey to each of the Nine Realms in search of answers as they prepare for the prophesied battle that will end the world.",
    cover: "https://images.igdb.com/igdb/image/upload/t_original/co5s5v.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/scd720.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scd71x.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scd71y.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scd71v.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scd71z.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/scd71w.jpg",
    ],
    videos: ["https://www.youtube.com/embed/g1wr0DfV73E"],
  },
  {
    id: 2,
    name: "Astro's Playroom",
    game_id: "93620",
    release: 1605139200,
    genre: [8, 31],
    platforms: [167],
    summary:
      "Astro and his crew lead you on a magical introduction through PS5 in this fun platformer that comes pre-loaded on PS5. Explore four worlds, each based on PS5’s console components. Each area showcases innovative gameplay that taps into the new features of the PS5's DualSense wireless controller.",
    cover: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2gw7.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bkl.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bko.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bkn.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bkp.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bkm.jpg",
    ],
    videos: ["https://www.youtube.com/embed/lu5VXrEqgco"],
  },
  {
    id: 3,
    name: "Sackboy: A Big Adventure",
    game_id: "134585",
    release: 1605139200,
    genre: [8, 31],
    platforms: [6, 48, 167],
    summary:
      "Iconic PlayStation hero, Sackboy returns in an all-new 3D adventure with a deeply immersive and expressive control scheme. Players can go on this epic platforming journey solo-style, or they can team up with friends for collaborative, chaotic multiplayer fun.Astro and his crew lead you on a magical introduction through PS5 in this fun platformer that comes pre-loaded on PS5. Explore four worlds, each based on PS5’s console components. Each area showcases innovative gameplay that taps into the new features of the PS5's DualSense wireless controller.",
    cover: "https://images.igdb.com/igdb/image/upload/t_cover_big/co4522.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bkl.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bko.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bkn.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bkp.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8bkm.jpg",
    ],
    videos: ["https://www.youtube.com/embed/9aJK8K_NnTE"],
  },
  {
    id: 4,
    name: "Marvel's Spider Man",
    game_id: "19565",
    release: 1536278400,
    genre: [25, 31],
    platforms: [48],
    summary:
      "Starring the world’s most iconic Super Hero, Spider-Man features the acrobatic abilities, improvisation and web-slinging that the wall-crawler is famous for, while also introducing elements never-before-seen in a Spider-Man game. From traversing with parkour and utilizing the environment, to new combat and blockbuster set pieces, it’s Spider-Man unlike any you’ve played before.",
    cover: "https://images.igdb.com/igdb/image/upload/t_original/co1r77.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/sc6khp.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6khv.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6khw.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6khq.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6khs.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6kht.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6khu.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6khx.jpg",
    ],
    videos: ["https://www.youtube.com/embed/q4GdJVvdxss"],
  },
  {
    id: 5,
    name: "God of War",
    game_id: "19560",
    release: 1524182400,
    genre: [12, 25, 31],
    platforms: [6, 48],
    summary:
      "God of War is the sequel to God of War III as well as a continuation of the canon God of War chronology. Unlike previous installments, this game focuses on Norse mythology and follows an older and more seasoned Kratos and his son Atreus in the years since the third game. It is in this harsh, unforgiving world that he must fight to survive… and teach his son to do the same.",
    cover: "https://images.igdb.com/igdb/image/upload/t_original/co1tmu.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/r7hpzsqic1bjwyzn1bnq.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/wunlbofh23trw0u67gms.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/s2zdtxopibrfjbxvpj5h.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/o4mg2wvhlcikaogvvzqe.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/gpt3d0gpue5mat4kkso6.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/mknszfnaifmhssbrmkpl.jpg",
    ],
    videos: ["https://www.youtube.com/embed/rClXqZD2Xrs"],
  },
  {
    id: 6,
    name: "Death Stranding",
    game_id: "19564",
    release: 1573171200,
    genre: [5, 31],
    platforms: [6, 48],
    summary:
      "From legendary game creator Hideo Kojima comes an all-new, genre-defying open world action adventure, starring Norman Reedus, Mads Mikkelsen, Léa Seydoux and Lindsay Wagner.\n\nIn the near future, mysterious explosions have rocked the globe, setting off a series of supernatural events known as the Death Stranding. With otherworldly creatures plaguing the landscape, and mass extinction imminent, it’s up to Sam Porter Bridges to travel across the ravaged wasteland and save humanity from impending annihilation.",
    cover: "https://images.igdb.com/igdb/image/upload/t_original/co1syk.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/ot22cc6wsmhbrcnuo8ti.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6l0f.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6l0e.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6l0b.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6l0a.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6l0c.jpg",
    ],
    videos: ["https://www.youtube.com/embed/tCI396HyhbQ"],
  },
  {
    id: 7,
    name: "Call of Duty: Black Ops 4",
    game_id: "83727",
    release: 1539302400,
    genre: [5],
    platforms: [6, 48, 49],
    summary:
      "Black Ops is back! Featuring gritty, grounded, fluid Multiplayer combat, the biggest Zombies offering ever with three full undead adventures at launch, and Blackout, where the universe of Black Ops comes to life in one massive battle royale experience featuring the largest map in Call of Duty history, signature Black Ops combat, characters, locations and weapons from the entire Black Ops series.",
    cover: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1wkf.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/sc6qen.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc6qem.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/ar6dr.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/gxrqetgeesus7abzlxsu.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/bofvxbntojlvpwueihdg.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/yyynkripplx43svs9ifw.jpg",
    ],
    videos: ["https://www.youtube.com/embed/3pyfKYwlGhQ"],
  },
  {
    id: 8,
    name: "Uncharted",
    game_id: "7331",
    release: 1462838400,
    genre: [5, 31],
    platforms: [48],
    summary:
      "Several years after his last adventure, retired fortune hunter, Nathan Drake, is forced back into the world of thieves. With the stakes much more personal, Drake embarks on a globe-trotting journey in pursuit of a historical conspiracy behind a fabled pirate treasure. His greatest adventure will test his physical limits, his resolve, and ultimately what he's willing to sacrifice to save the ones he loves.",
    cover: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1r7h.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/fn1wbuvikoacxt4zvfxl.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/b41umzxjcehm8fozl3gf.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/tqt0sxjytiovh3g96cl0.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/qwytrspu8brvow9x9y15.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/rtu8k7vm5x4mw5hilh2z.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/yyynkripplx43svs9ifw.jpg",
    ],
    videos: ["https://www.youtube.com/embed/3pyfKYwlGhQ"],
  },
  {
    id: 9,
    name: "Minecraft: Playstation 4 Edition",
    game_id: "93620",
    release: 1409788800,
    genre: [32, 31],
    platforms: [48],
    summary:
      "The critically acclaimed Minecraft comes to PlayStation 4. Create your very own game world and explore, build and conquer.",
    cover: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1ur4.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/f0mtqk9zdqoulrf0nfzu.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/jf38rmtqfajincjbmlhk.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/ggo7l7nmnscwm2dxwxpm.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/u96la3yypflh3px1x4zc.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/f0mtqk9zdqoulrf0nfzu.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/plhsbped062flaoknbzt.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/diq3mxcap0gnbbgeqpwg.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/o5ibznm0jhxvumujptuv.jpg",
    ],
    videos: ["https://www.youtube.com/embed/1DhWXAiNgfQ"],
  },
  {
    id: 10,
    game_id: "26192",
    name: "The Last of Us Part II",
    release: 1592524800,
    genre: [5, 31],
    platforms: [48],
    summary:
      "Set 5 years after the events of The Last of Us, we see the return of Joel and Ellie. Driven by hatred, Ellie sets out for Seattle to serve justice. However, she begins to wonder what justice really means.",
    cover: "https://images.igdb.com/igdb/image/upload/t_cover_big/co5xff.jpg",
    screenshots: [
      "https://images.igdb.com/igdb/image/upload/t_original/rqr5dxxw97zikyhdn2tq.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/kazgjykzu18dhqjpspko.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8i94.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8i96.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8i93.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8i95.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/sc8i97.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/oh8a5shtmdbqx73cv765.jpg",
      "https://images.igdb.com/igdb/image/upload/t_original/rdonk4uvyh8ijanrbs46.jpg",
    ],
    videos: [
      "https://www.youtube.com/embed/jziBvTUdCB0",
      "https://www.youtube.com/embed/gF1EQAtaZEo",
      "https://www.youtube.com/embed/ArAdN5ilVRs",
      "https://www.youtube.com/embed/II5UsqP2JAk",
      "https://www.youtube.com/embed/t-BUJoqZRsw",
      "https://www.youtube.com/embed/mRj3B3GY9KM",
      "https://www.youtube.com/embed/muniWyT4vTg",
      "https://www.youtube.com/embed/HfxOtvmpsM8",
    ],
  },
];

export default GAMES;
